<template>
  <div>
    <b-modal
      @hidden="clearForm"
      v-model="modalShow"
      title="Stock Management"
      centered
      footer-class="content-between"
    >
      <b-tabs fill v-model="form.edit_type">
        <b-tab title="Received">
          <div class="container-stock">
            <InputSelect
              placeholder="Stock"
              title="Stock"
              v-model="form.stock_type_id"
              :disabled="stockDisabled"
              :isValidate="$v.form.stock_type_id.$error"
              :v="$v.form.stock_type_id"
              valueField="id"
              @onDataChange="handleInventoryReceive($event)"
              textField="name"
              :options="listStock"
            >
              <template v-slot:option-first>
                <b-form-select-option :value="0" disabled
                  >-- Select Stock --</b-form-select-option
                >
              </template>
            </InputSelect>

            <!-- <div class="current-stock">Current Stock : {{ form.stock }}</div> -->
            <div v-if="form.is_serial">
              <b-row>
                <b-col cols="12">
                  <label class="main-label">Serial</label>
                </b-col>
              </b-row>
              <div class="px-3 maxheight-290px">
                <b-row
                  v-for="(item, index) in form.serial"
                  :key="`serial-received-${index}`"
                >
                  <b-col cols="1" class=""
                    ><div class="d-flex justify-content-center mt-2">
                      #{{ index + 1 }}
                    </div>
                  </b-col>
                  <b-col cols="10" class="p-0">
                    <InputText
                      textFloat=""
                      placeholder="Serial"
                     
                      :isValidate="$v.form.serial.$each[index].$error"
                      :v="$v.form.serial.$each[index]"
                      v-model="form.serial[index]"
                    />
                  </b-col>
                  <b-col cols="1" class="">
                    <div class="d-flex justify-content-center">
                      <b-button
                        variant="icon"
                        class="px-0"
                        :class="{
                          'text-gray-1': index == 0,
                          'text-error': index != 0,
                        }"
                        @click="deleteSerial(index)"
                      >
                        <b-icon icon="trash-fill"></b-icon>
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col cols="12">
                  <div
                    class="main-label text-link main-color"
                    @click="addSerial()"
                  >
                    Add New Serial
                  </div>
                </b-col>
              </b-row>
            </div>
            <InputText
              v-else
              textFloat="Amount"
              placeholder="Add Amount"
              type="number"
              name="Amount"
              v-model="form.amount"
              :disabled="form.stock_type_id === 0"
              @input="handleAmoutInput"
              :isValidate="$v.form.amount.$error"
              :v="$v.form.amount"
            />

            <InputText
              textFloat=""
              customLabel
              placeholder="Available"
              type="number"
              name="Available"
              disabled
              v-model="form.available"
            >
              <template v-slot:textFloat>
                <div class="content-between">
                  <div class="main-label">Available</div>
                  <div class="current-stock">
                    Current Stock : {{ form.stock }}
                  </div>
                </div>
              </template>
            </InputText>
            <InputTextArea
              :rows="4"
              textFloat="Additional Notes"
              placeholder="Additional Notes"
              id="note"
              v-model="form.note"
            />
          </div>
        </b-tab>
        <b-tab title="Damaged">
          <div class="container-stock">
            <InputSelect
              placeholder="Stock"
              title="Stock"
              v-model="form.stock_type_id"
              :disabled="stockDisabled"
              :isValidate="$v.form.stock_type_id.$error"
              :v="$v.form.stock_type_id"
              valueField="id"
              @onDataChange="handleInventoryReceive($event)"
              textField="name"
              :options="listStock"
            >
              <template v-slot:option-first>
                <b-form-select-option :value="0" disabled
                  >-- Select Stock --</b-form-select-option
                >
              </template>
            </InputSelect>
            <!-- <div class="current-stock">Current Stock : {{ form.stock }}</div> -->
            <div v-if="form.is_serial">
              <b-row>
                <b-col cols="12">
                  <label class="main-label">Serial</label>
                </b-col>
              </b-row>
              <div class="px-3 maxheight-290px">
                <b-row
                  v-for="(item, index) in listSerial"
                  :key="`serial-damage-${index}`"
                >
                  <b-col cols="1" class=""
                    ><div class="d-flex justify-content-center mt-2">
                      #{{ index + 1 }}
                    </div>
                  </b-col>
                  <b-col cols="10" class="p-0">
                    <InputText
                      textFloat=""
                      :disabled="true"
                      placeholder="Serial"
                      type="text"
                      v-model="item.serial"
                    />
                  </b-col>
                  <b-col cols="1" class="">
                    <b-form-checkbox
                      class="pl-3 mt-2"
                      :id="item.serial"
                      name="damage"
                      :disabled="!form.stock_type_id"
                      :value="item.serial"
                      :checked="form.serial"
                      :unchecked-value="false"
                      @change="inputSerial(item.serial, 0)"
                    >
                    </b-form-checkbox>
                  </b-col>
                </b-row>
                <div v-if="$v.form.serial.$error" class="text-error">
                  Please Select Serial
                </div>
              </div>
            </div>
            <InputText
              v-else
              textFloat="Amount"
              placeholder="Add Amount"
              type="number"
              name="Amount"
              v-model="form.amount"
              :disabled="form.stock_type_id === 0"
              @input="handleAmoutInput"
              :isValidate="$v.form.amount.$error"
              :v="$v.form.amount"
            />
            <InputText
              textFloat=""
              customLabel
              placeholder="Available"
              type="number"
              name="Available"
              disabled
              v-model="form.available"
            >
              <template v-slot:textFloat>
                <div class="content-between">
                  <div class="main-label">Available</div>
                  <div class="current-stock">
                    Current Stock : {{ form.stock }}
                  </div>
                </div>
              </template>
            </InputText>
            <InputTextArea
              :rows="4"
              textFloat="Additional Notes"
              placeholder="Additional Notes"
              id="note"
              v-model="form.note"
            /></div
        ></b-tab>
        <b-tab title="Adjust" v-if="!form.is_serial">
          <div class="container-stock">
            <InputSelect
              placeholder="Stock"
              title="Stock"
              v-model="form.stock_type_id"
              :disabled="stockDisabled"
              :isValidate="$v.form.stock_type_id.$error"
              :v="$v.form.stock_type_id"
              valueField="id"
              @onDataChange="handleInventoryReceive($event)"
              textField="name"
              :options="listStock"
            >
              <template v-slot:option-first>
                <b-form-select-option :value="0" disabled
                  >-- Select Stock --</b-form-select-option
                >
              </template>
            </InputSelect>

            <!-- <InputText

              placeholder="Add Amount"
              type="number"
              name="Amount"
              v-model="form.amount"
              :isValidate="$v.form.amount.$error"
              :v="$v.form.amount"
            /> -->
            <InputText
              textFloat=""
              customLabel
              placeholder="Add Amount"
              type="number"
              name="Amount"
              v-model="form.amount"
              :isValidate="$v.form.amount.$error"
              :disabled="form.stock_type_id === 0"
              :v="$v.form.amount"
            >
              <template v-slot:textFloat>
                <div class="content-between">
                  <div class="main-label">Amount</div>
                  <div class="current-stock">
                    Current Stock : {{ form.stock }}
                  </div>
                </div>
              </template>
            </InputText>
            <!-- <InputText
              textFloat=""
              customLabel
              placeholder="Available"
              type="number"
              name="Available"
              disabled
              v-model="form.available"
            >
              <template v-slot:textFloat>
                <div class="content-between">
                  <div class="main-label">Available</div>
                  <div class="current-stock">
                    Current Stock : {{ form.stock }}
                  </div>
                </div>
              </template>
            </InputText> -->
            <InputTextArea
              :rows="4"
              textFloat="Additional Notes"
              placeholder="Additional Notes"
              id="note"
              v-model="form.note"
            /></div
        ></b-tab>
        <b-tab title="Move">
          <div class="container-stock">
            <InputSelect
              placeholder="Stock"
              title="Form Stock"
              v-model="form.inventory_from"
              :isValidate="$v.form.inventory_from.$error"
              :v="$v.form.inventory_from"
              @onDataChange="handleInventoryFrom($event, 0)"
              valueField="id"
              :disabled="stockDisabled"
              textField="name"
              :options="listStock"
            >
              <template v-slot:option-first>
                <b-form-select-option :value="0" disabled
                  >-- Select Stock --</b-form-select-option
                >
              </template>
            </InputSelect>
            <div v-if="form.is_serial">
              <b-row>
                <b-col cols="12">
                  <label class="main-label">Serial</label>
                </b-col>
              </b-row>
              <div class="px-3 maxheight-290px">
                <b-row
                  v-for="(item, index) in listSerial"
                  :key="`serial-move-${index}`"
                >
                  <b-col cols="1" class=""
                    ><div class="d-flex justify-content-center mt-2">
                      #{{ index + 1 }}
                    </div>
                  </b-col>
                  <b-col cols="10" class="p-0">
                    <InputText
                      textFloat=""
                      :disabled="true"
                      placeholder="Serial"
                      type="text"
                      v-model="item.serial"
                    />
                  </b-col>
                  <b-col cols="1" class="">
                    <b-form-checkbox
                      class="pl-3 mt-2"
                      name=""
                      :disabled="!form.inventory_from"
                      :value="item.serial"
                      :checked="form.serial"
                      :unchecked-value="false"
                      @change="inputSerial(item.serial, 1)"
                    >
                    </b-form-checkbox>
                  </b-col>
                </b-row>

                <div v-if="$v.form.serial.$error" class="text-error">
                  Please Select Serial
                </div>
              </div>
            </div>
            <InputText
              v-else
              textFloat="Amount"
              placeholder="Add Amount"
              type="number"
              name="Amount"
              v-model="form.amount"
              @input="handleAmoutInput"
              :isValidate="$v.form.amount.$error"
              :disabled="form.inventory_from === 0"
              :v="$v.form.amount"
            />

            <InputText
              textFloat=""
              customLabel
              placeholder="Available"
              type="number"
              name="Available"
              disabled
              v-model="form.available"
            >
              <template v-slot:textFloat>
                <div class="content-between">
                  <div class="main-label">Available</div>
                  <div class="current-stock">
                    Current Stock : {{ form.stock_from }}
                  </div>
                </div>
              </template>
            </InputText>

            <InputSelect
              placeholder="Stock"
              title="To Stock"
              v-model="form.stock_type_id"
              :isValidate="$v.form.stock_type_id.$error"
              :v="$v.form.stock_type_id"
              @onDataChange="handleInventoryFrom($event, 1)"
              valueField="id"
              :disabled="!form.inventory_from"
              textField="name"
              :options="listStockTo"
            >
              <template v-slot:option-first>
                <b-form-select-option :value="0" disabled
                  >-- Select Stock --</b-form-select-option
                >
              </template>
            </InputSelect>

            <InputText
              textFloat=""
              customLabel
              placeholder="Available"
              type="number"
              name="Available"
              disabled
              v-model="form.available_to"
            >
              <template v-slot:textFloat>
                <div class="content-between">
                  <div class="main-label">Available</div>
                  <div class="current-stock">
                    Current Stock : {{ form.stock }}
                  </div>
                </div>
              </template>
            </InputText>
            <InputTextArea
              :rows="4"
              textFloat="Additional Notes"
              placeholder="Additional Notes"
              id="note"
              v-model="form.note"
            /></div
        ></b-tab>
      </b-tabs>
      <template #modal-footer>
        <b-row>
          <b-col class="text-left">
            <b-button @click.prevent="clearForm" class="border-btn"
              >Cancel</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="submit-btn" @click.prevent="handleOk()"
              >Confirm
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { requiredIf, minValue } from "vuelidate/lib/validators";
const minInventoryForm = (value, form) => {
  return !(
    ((form.is_serial && form.edit_type == 2) || form.edit_type == 3 ) &&
    value == 0
  );
};

const minAmount = (value, form) => {
  return !(
    ((form.is_serial && form.edit_type == 2) || form.edit_type == 3 || form.edit_type == 1 || form.edit_type == 0) &&
    value == 0
  );
};
export default {
  props: {
    stock_id: { required: false, default: 0 },
  },
  data() {
    return {
      modalShow: false,
      form: {
        inventory_id: 0,
        branch_id: Number(this.$route.params.id),
        product_id: 0,
        stock: 0,
        inventory_from: 0,
        stock_from: 0,
        amount: "",
        edit_type: 0,
        note: "",
        available: 0,
        is_serial: 0,
        serial: [],
        stock_type_id: this.stock_id,
        available_to: 0,
      },
      // move_from: {
      //   stock_type_id: null,
      //   inventory_from: null,
      //   branch_id: Number(this.$route.params.id),
      //   stock_form: 0,
      //   product_id: 0,
      //   inventory_id: 0,
      //   edit_type: 4,
      // },
      tabsIndex: 1,
      isHaveItems: false,
      listStock: [],
      listStockTo: [],
      listActiveSerial: [],
      listSerial: [],
    };
  },
  validations: {
    form: {
      amount: {
        required: requiredIf(function (item) {
          return !item.is_serial;
        }),
        minAmount(){
          return minAmount(this.form.amount, this.form);
        }
      },
      stock_type_id: {
        minValue: minValue(1),
      },
      inventory_from: {
        minInventoryForm() {
          return minInventoryForm(this.form.inventory_from, this.form);
        },
      },
      serial: {
        required: requiredIf(function () {
          return (
            this.form.is_serial &&
            (this.form.edit_type == 1 || this.form.edit_type == 2)
          );
        }),
        $each: {
          required: requiredIf(function () {
            return this.form.edit_type == 0;
          }),
        },
      },
    },
  },
  computed: {
    stockDisabled() {
      return this.stock_id != 0;
    },
  },
  watch: {
    "form.edit_type"(val) {
      this.$v.form.$reset();
      this.listSerial = [];
      this.form.stock_from = 0;
      return (
        (this.form.amount = ""),
        (this.form.stock = 0),
        (this.form.stock_type_id = val == 3 ? 0 : this.stock_id),
        (this.form.inventory_from = val == 3 ? this.stock_id : 0),
        (this.form.available = 0),
        (this.form.available_to = 0),
        this.form.is_serial && this.form.edit_type == 0
          ? (this.form.serial = [""])
          : (this.form.serial = [])
      );
    },
  },
  methods: {
    handleAmoutInput(value, $event) {
      if (this.form.edit_type == 1 || this.form.edit_type == 3) {
        let stock =
          this.form.edit_type == 3 ? this.form.stock_from : this.form.stock;

        if (stock < this.form.amount) {
          return this.$nextTick(() => {
            $event.preventDefault();

            this.form.amount = Number(stock);
            this.form.available = 0;
            return ($event.target.value = Number(stock));
          });
        }
      }
      if (this.form.edit_type == 0) {
        let amount = this.form.amount ? this.form.amount : 0;
        this.form.available = Number(amount) + Number(this.form.stock);
      } else if (
        this.form.edit_type == 3 ||
        (this.form.is_serial && this.form.edit_type == 2)
      ) {
        let amount = this.form.amount ? this.form.amount : 0;
        this.form.available = Number(this.form.stock_from) - Number(amount);
        this.form.available_to = this.form.stock_type_id ? Number(this.form.stock) + Number(amount) : 0;
      } else {
        let amount = this.form.amount ? this.form.amount : 0;
        this.form.available = Number(this.form.stock) - Number(amount);
      }
    },
    async handleOk() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      this.form.amount = Number(this.form.amount);
      let edit_type = this.form.edit_type + 1;
      if ((this.form.is_serial && edit_type == 3) || edit_type == 4) {
        edit_type = 9;
      }
      //Check Serial
      if (this.form.is_serial && edit_type == 1) {
        const hasDuplicates = this.form.serial.some(
          (item, index) => this.form.serial.indexOf(item) !== index
        );
        if (hasDuplicates) {
          this.errorAlert("Duplicate serial number");

          return;
        } else {
          let validate = await this.validateSerial();
          if (!validate) {
            return;
          }
        }
      }

      this.$bus.$emit("showLoading");

      const response = await this.axios.post(`/Inventory/UpdateInventory`, {
        ...this.form,
        edit_type: edit_type,
      });

      if (response.data.result) {
        this.modalShow = false;
        this.successAlert();
      } else this.errorAlert(response.data.message);

      this.$emit("getData");
      this.$bus.$emit("hideLoading");
    },
    async validateSerial() {
      const res = await this.axios.post(
        `/Inventory/UpdateInventory/validate/serial`,
        this.form
      );
      if (!res.data.detail.result) {
        this.errorAlert(res.data.detail.message);
        return false;
      }
      return true;
    },
    async show(items) {
      const res = await this.axios.get(
        `/Inventory/GetActiveStockType/${items.branch_id}/${items.product_id}`
      );
      if (res.data.result) {
        this.listStock = res.data.detail.map((x) => ({
          ...x,
          name: x.name + " (" + x.stock + ")",
          disabled: false,
        }));
        this.listStockTo = this.listStock;
      }
      this.isHaveItems = true;

      this.form.edit_type = 0;

      this.form.is_serial = items.is_serial;

      this.form.serial = items.is_serial ? [""] : [];
      this.form.product_id = items.product_id;
      this.form.note = items.note || "";
      this.form.branch_id = items.branch_id || Number(this.$route.params.id);
      this.modalShow = true;
    },
    clearForm() {
      this.$v.form.$reset();
      this.$v.form.serial.$reset();
      this.form = {
        inventory_id: 0,
        branch_id: Number(this.$route.params.id),
        product_id: 0,
        stock: 0,
        inventory_from: 0,
        stock_from: 0,
        amount: "",
        edit_type: 0,
        note: "",
        available: 0,
        is_serial: 0,
        serial: [],
        stock_type_id: 0,
        available_to: 0,
      };
      this.listSerial = [];
      this.modalShow = false;
    },
    addSerial() {
      this.form.serial.push("");
      this.form.available += 1;
    },
    deleteSerial(index) {
      if (index == 0) {
        return;
      } else {
        this.form.serial.splice(index, 1);
        this.form.available -= 1;
      }
    },
    async handleInventoryReceive(input) {
      this.form.inventory_id = this.listStock.find(
        (x) => x.id == input
      ).inventory_id;

      this.form.available =
        this.form.is_serial && this.form.edit_type == 0
          ? this.listStock.find((x) => x.id == input).stock + 1
          : this.listStock.find((x) => x.id == input).stock;
      this.form.stock = this.listStock.find((x) => x.id == input).stock;
      await this.getSerialFromStock();
    },
    async handleInventoryFrom(input, isToStock) {
      if (!isToStock) {
        this.listStockTo = this.listStock.map((x) => ({
          ...x,
          disabled: false,
        }));
        //Clear stock to
        this.form.stock_type_id = 0;
        this.form.available_to = 0;
        this.form.stock = 0;
        //Clear stock to
        this.form.amount = "";
        this.form.stock_from = this.listStock.find((x) => x.id == input).stock;
        this.form.available = this.listStock.find((x) => x.id == input).stock;

        const stockToItem = this.listStockTo.find((x) => x.id == input);
        if (stockToItem) {
          stockToItem.disabled = true;
        }
        await this.getSerialFromStock();
      } else {
        let stockToItem = this.listStockTo.find((x) => x.id == input);
        this.form.available_to = this.form.is_serial
          ? stockToItem.stock + this.form.serial.length
          : stockToItem.stock + this.form.amount;
        this.form.stock = this.listStock.find((x) => x.id == input).stock;

        this.form.inventory_id = this.listStockTo.find(
          (x) => x.id == input
        ).inventory_id;
      }
    },
    async getSerialFromStock() {
      if (this.form.is_serial) {
        const responseSerial = await this.axios(
          `/Inventory/GetInventorySerial/${this.form.branch_id}/${this.form.product_id}/${this.form.stock_type_id}`
        );
        this.listSerial = responseSerial.data.detail;
      }
    },

    inputSerial(serial, isMove) {
      if (this.form.serial.includes(serial)) {
        this.form.serial = this.form.serial.filter((item) => item !== serial);
        this.form.available += 1;
        if (isMove && this.form.stock_type_id) {
          this.form.available_to -= 1;
        }
      } else {
        this.form.serial.push(serial);

        this.form.available -= 1;
        if (isMove && this.form.stock_type_id) {
          this.form.available_to += 1;
        }
      }
    },
  },
};
</script>

<style scoped>
::v-deep .nav.nav-tabs.nav-fill {
  border: 10px solid #c5c5c5;
}
::v-deep .modal-body {
  padding: 0;
}
::v-deep .nav-tabs .nav-link.active,
::v-deep .nav-tabs .nav-item.show .nav-link {
  background-color: var(--primary-color);
  border-bottom: none;
  color: #fff !important;
}
::v-deep .nav-tabs .nav-item .nav-item:last-child {
  padding-right: 0px;
}

.container-stock {
  position: relative;
  padding: 1.5rem;
}
.current-stock {
  color: rgb(146, 146, 146);
  /* position: absolute; */
  /* top: calc(0px+ 1.5rem); */
  font-size: 12px;
  /* top: calc(0px+ 1.5rem); */
  /* right: calc(0px + 1.5rem); */
}

.maxheight-290px {
  max-height: 290px !important;
  overflow: auto;
}
</style>
